const TIERS = [
  { name: 'Listener', min: 0,   next: 10  },
  { name: 'Reader',   min: 10,  next: 25  },
  { name: 'Student',  min: 25,  next: 50  },
  { name: 'Scholar',  min: 50,  next: 100 },
  { name: 'Hafiz',    min: 100, next: null },
];

// eslint-disable-next-line react-refresh/only-export-components
export function getTierInfo(readCount) {
  let tier = TIERS[0];
  for (const t of TIERS) { if (readCount >= t.min) tier = t; }
  const tierSize   = tier.next ? tier.next - tier.min : 50;
  const withinTier = readCount - tier.min;
  const ringPct    = Math.min(1, withinTier / tierSize);
  const nextTier   = tier.next ? TIERS.find(t => t.min === tier.next) : null;
  const toNext     = nextTier ? nextTier.min - readCount : null;
  return {
    tierName:     tier.name,
    ringPct,
    withinTier:   tier.next ? withinTier : withinTier % 50,
    tierSize:     tier.next ? tierSize : 50,
    nearMiss:     toNext !== null && toNext <= 5 ? toNext : null,
    nextTierName: nextTier?.name ?? null,
  };
}

export function RingProgress({ pct, size = 34 }) {
  const r    = (size - 5) / 2;
  const circ = 2 * Math.PI * r;
  return (
    <svg width={size} height={size} style={{ transform: 'rotate(-90deg)', flexShrink: 0 }}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--border)" strokeWidth="3" />
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--gold)" strokeWidth="3"
        strokeDasharray={`${pct * circ} ${circ}`} strokeLinecap="round" />
    </svg>
  );
}

export function TierDisplay({ readCount, pathKey }) {
  const { tierName, ringPct, withinTier, tierSize, nearMiss, nextTierName } = getTierInfo(readCount);

  const lsKey      = `diwan_tier_${pathKey}`;
  const lastTier   = localStorage.getItem(lsKey);
  const justLeveled = lastTier && lastTier !== tierName && readCount > 0;
  if (justLeveled)             localStorage.setItem(lsKey, tierName);
  else if (!lastTier && readCount > 0) localStorage.setItem(lsKey, tierName);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginTop: '0.4rem' }}>
      <RingProgress pct={ringPct} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.45rem' }}>
          <span style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '0.6rem', letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--gold)' }}>
            {tierName}
          </span>
          <span style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '0.58rem', letterSpacing: '0.06em', color: 'var(--text3)' }}>
            {readCount > 0 ? `${readCount} read` : null}
          </span>
          <span style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '0.52rem', letterSpacing: '0.04em', color: 'var(--text3)', opacity: 0.6, marginLeft: 'auto' }}>
            {withinTier}/{tierSize}
          </span>
        </div>
        {justLeveled ? (
          <div style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '0.54rem', letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--gold)', marginTop: '0.15rem' }}>
            ✦ Reached {tierName}
          </div>
        ) : nearMiss ? (
          <div style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '0.54rem', letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--em)', marginTop: '0.15rem' }}>
            {nearMiss} more to reach {nextTierName} →
          </div>
        ) : readCount === 0 ? (
          <div style={{ fontFamily: "'Josefin Sans', sans-serif", fontSize: '0.54rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--em)', marginTop: '0.15rem' }}>
            → Begin
          </div>
        ) : null}
      </div>
    </div>
  );
}
